import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../../hooks/use-define-slot';

const AdContainer = styled.div`
  height: 90px;
  margin: 0 auto;
`;

export const DisplayAdProfileLeaderboard: React.FC<{ refresh: boolean }> = ({
  refresh,
}) => {
  const { id, adUnitPath, size } = adSlotConfig.Profile.Leaderboard;
  useDefineSlot({ id, adUnitPath, size, refresh });

  return <AdContainer id={id} />;
};
